// Arabic (AR) — AI-prepared, pending native review before production.
// Keys override the English master copy carried as component defaults.
export default {
  // SEO
  "seo.title": "افتح صالتك الرياضية — معدات مباشرة من المصنع | YANRE FITNESS EUROPE",
  "seo.description": "من الاستوديو الخاص إلى المنشأة التجارية الكبيرة — معدات YANRE الاحترافية، استشارات مشاريع مخصصة، لوجستيات دولية وخدمة ما بعد البيع بضمان المصنع.",

  // Header / nav
  "nav.Why Fitness": "لماذا اللياقة",
  "nav.Why YANRE": "لماذا YANRE",
  "nav.How It Works": "كيف نعمل",
  "nav.Real Projects": "مشاريع حقيقية",
  "nav.visitWebsite": "زيارة الموقع",
  "header.cta": "ابدأ مشروعك",

  // Hero
  "hero.label": "افتح صالتك الرياضية",
  "hero.line1": "ابنِ صالتك الرياضية.",
  "hero.line2a": "اشترِ مباشرة من",
  "hero.line2b": "المصنّع.",
  "hero.copy": "من الاستوديوهات الخاصة إلى المنشآت التجارية الكبيرة — معدات YANRE الاحترافية، استشارات مشاريع مخصصة، دعم لوجستي دولي وخدمة ما بعد البيع بضمان المصنع.",
  "hero.ctaPrimary": "ابدأ مشروع صالتي الرياضية",
  "hero.ctaSecondary": "تحدث مع خبير",
  "hero.trust.0": "مباشرة من المصنع",
  "hero.trust.1": "استشارات المشاريع",
  "hero.trust.2": "لوجستيات دولية",
  "hero.trust.3": "ضمان المصنع",

  // Marquee
  "marquee.Precision": "الدقة",
  "marquee.Performance": "الأداء",
  "marquee.Confidence": "الثقة",
  "marquee.Engineering": "الهندسة",
  "marquee.Since 1997": "منذ 1997",

  // CTA strips
  "strip.1": "مستعد للتحدث عن مشروعك؟",
  "strip.2": "تعرف ما تحتاجه؟ لنتحدث.",
  "strip.3": "رأيت ما يكفي؟ ابدأ مشروعك.",
  "strip.cta": "ابدأ مشروعك",

  // Section labels (SectionLabel children as keys)
  "label.Why Invest in Fitness": "لماذا الاستثمار في اللياقة",
  "label.Fitness Market Proof": "أدلة سوق اللياقة",
  "label.New to Fitness? That's OK.": "جديد في عالم اللياقة؟ لا بأس.",
  "label.Factory Direct": "مباشرة من المصنع",
  "label.Factory Direct Purchase Process": "عملية الشراء مباشرة من المصنع",
  "label.Featured Equipment": "معدات مميزة",
  "label.Engineered Differently": "هندسة مختلفة",
  "label.Built Around Your Business": "مصمم حول عملك",
  "label.Why YANRE FITNESS": "لماذا YANRE FITNESS",
  "label.The Founder": "المؤسس",
  "label.YANRE Gyms Around the World": "صالات YANRE حول العالم",
  "label.International Logistics": "اللوجستيات الدولية",
  "label.After-Sales & Warranty": "ما بعد البيع والضمان",
  "label.Start Your Project": "ابدأ مشروعك",
  "label.Milestones": "المحطات",
  "label.Engineering Philosophy": "فلسفة الهندسة",

  // WhatsApp
  "wa.title": "واتساب",
  "wa.subtitle": "تحدث مع خبير",

  // Footer
  "footer.contact": "اتصل بنا",
  "footer.legal": "قانوني",
  "footer.privacy": "سياسة الخصوصية",
  "footer.cookies": "سياسة ملفات تعريف الارتباط",
  "footer.terms": "الشروط",
  "footer.visit": "زيارة موقع YANRE FITNESS EUROPE",

  // Form — steps
  "step.1": "المشروع",
  "step.2": "المساحة",
  "step.3": "الاستثمار",
  "step.4": "التواصل",
  "step.5": "احتياجات المشروع",
  "step.6": "اللوجستيات",
  "step.7": "الشراء",
  "step.8": "دورك",
  "step.9": "الموقع",
  "step.10": "التواصل",
  "step.11": "المعلومات النهائية",
  "form.progress": "الخطوة",
  "form.title1": "ابنِ مشروع",
  "form.title2": "صالتك الرياضية.",
  "form.subtitle": "أخبرنا بما تخطط له. سنساعدك في بناء حل المعدات المناسب.",
  "form.intro.sub1": "٤ خطوات سريعة.",
  "form.intro.sub2": "حل متكامل لناديك الرياضي.",
  "form.intro.support": "أخبرنا عن مشروعك في ٤ خطوات بسيطة فقط. سيفهم فريقنا احتياجاتك ويساعدك في بناء الحل المناسب — مع التوريد المباشر من مصنع YANRE FITNESS في الصين، واستشارة احترافية ودعم ما بعد البيع.",
  "form.intro.minute": "دقيقة واحدة للإكمال",
  "form.back": "رجوع",
  "form.continue": "متابعة",
  "form.submit": "احصل على مشروع النادي الخاص بي",
  "form.sending": "جارٍ الإرسال…",

  // Form — questions
  "q.projectType": "ما الذي يصف مشروعك بشكل أفضل؟",
  "q.franchiseStatus": "هل أنت مرتبط بامتياز لياقة بدنية (فرانشايز)؟",
  "q.locationStatus": "هل لديك موقع للمشروع بالفعل؟",
  "q.facilityArea": "ما هي المساحة الأرضية التقريبية المتاحة؟",
  "q.projectStage": "في أي مرحلة يوجد مشروعك؟",
  "q.openingTimeline": "متى تخطط لافتتاح مشروعك؟",
  "q.investmentBand": "ما هو نطاق الاستثمار التقديري؟ (USD)",
  "q.investmentHint": "يكفي تقدير تقريبي. يساعدنا ذلك على التوصية بالحل المناسب لمشروعك.",
  "q.projectNeed": "ما الذي تحتاجه لمشروعك؟",
  "q.projectNeedHint": "اختر كل ما ينطبق.",
  "q.equipmentListStatus": "هل لديك قائمة معدات بالفعل؟",
  "q.logisticsPreference": "كيف تريد التعامل مع اللوجستيات الدولية؟",
  "q.purchaseMethod": "كيف تخطط حاليًا لشراء معداتك؟",
  "q.competitorComparison": "هل تقارن حاليًا علامات معدات أخرى؟",
  "q.competitorBrands": "ما العلامات التي تفكر فيها؟",
  "q.decisionRole": "ما دورك في هذا المشروع؟",
  "q.country": "بلد المشروع",
  "q.city": "المدينة",
  "q.firstName": "الاسم الأول",
  "q.lastName": "اسم العائلة",
  "q.company": "الشركة / اسم النادي (اختياري)",
  "q.email": "البريد الإلكتروني",
  "q.phone": "واتساب / الهاتف",
  "q.preferredContact": "طريقة التواصل المفضلة",
  "q.notes": "هل هناك أي شيء آخر يجب أن نعرفه عن مشروعك؟",
  "q.optional": "اختياري",
  "q.selectCountry": "اختر البلد",

  // Form — option labels (canonical values unchanged)
  "opt.commercial-gym": "مشروع نادٍ متكامل",
  "opt.boutique-gym": "صالة بوتيك",
  "opt.pt-studio": "استوديو تدريب شخصي",
  "opt.home-gym": "صالة منزلية خاصة",
  "opt.residential-gym": "نادٍ سكني / لمجمع سكني",
  "opt.hotel-resort": "لياقة الفنادق / المنتجعات",
  "opt.corporate-gym": "نادٍ للشركات",
  "opt.sports-facility": "منشأة رياضية / أداء",
  "opt.franchise": "امتياز نادٍ رياضي",
  "opt.other": "أخرى",
  "opt.own-franchise": "نعم — أمتلك / أدير امتيازًا بالفعل",
  "opt.acquiring-franchise": "نعم — أقوم بالاستحواذ على امتياز",
  "opt.evaluating-franchise": "أقيّم فرص الامتياز",
  "opt.independent": "لا — أستكشف قطاع اللياقة بشكل مستقل",
  "opt.confirmed": "نعم — الموقع مؤكد",
  "opt.negotiating": "أتفاوض على موقع",
  "opt.looking": "ما زلت أبحث عن موقع",
  "opt.up-to-100": "حتى 100 م²",
  "opt.100-250": "100–250 م²",
  "opt.250-500": "250–500 م²",
  "opt.500-1000": "500–1,000 م²",
  "opt.1000-2000": "1,000–2,000 م²",
  "opt.2000-plus": "أكثر من 2,000 م²",
  "opt.exploring": "أستكشف فرص الاستثمار",
  "opt.initial-planning": "تخطيط أولي",
  "opt.business-plan": "خطة عمل / تخطيط استثماري",
  "opt.location-selected": "تم اختيار الموقع",
  "opt.architecture": "هندسة معمارية / تصميم",
  "opt.construction": "إنشاء / تجديد",
  "opt.ready-to-purchase": "جاهز لشراء المعدات",
  "opt.expansion": "افتتاح وحدة جديدة / توسعة",
  "opt.within-2": "خلال شهرين",
  "opt.2-4": "2–4 أشهر",
  "opt.4-6": "4–6 أشهر",
  "opt.6-12": "6–12 شهرًا",
  "opt.12-plus": "أكثر من 12 شهرًا",
  "opt.up-to-50k": "أقل من USD 50,000",
  "opt.50-150k": "USD 50,000–150,000",
  "opt.150-300k": "USD 150,000–300,000",
  "opt.300-500k": "USD 300,000–500,000",
  "opt.500k-1m": "USD 500,000–1M",
  "opt.1m-plus": "أكثر من USD 1M",
  "opt.complete-equipment": "معدات صالة متكاملة",
  "opt.strength": "معدات القوة",
  "opt.cardio": "معدات الكارديو",
  "opt.full-project-help": "أحتاج مساعدة في المشروع بالكامل",
  "opt.have-list": "نعم — لديّ قائمة معدات بالفعل",
  "opt.need-review": "جزئياً — لديّ تشكيلة أولية",
  "opt.need-list": "لا — أحتاج مساعدة YANRE",
  "opt.yanre-coordination": "أريد تنسيق لوجستيات YANRE",
  "opt.own-partner": "لدي شريك لوجستي بالفعل",
  "opt.compare-both": "أريد مقارنة الخيارين",
  "opt.need-guidance": "أحتاج إرشادًا قبل اتخاذ القرار",
  "opt.direct": "مباشرة من المصنّع",
  "opt.dealer": "وكيل معدات لياقة محلي",
  "opt.distributor": "موزع / مستورد",
  "opt.comparing": "أقارن خيارات شراء مختلفة",
  "opt.researching": "ما زلت أبحث عن موردين",
  "opt.yes": "نعم",
  "opt.no": "لا",
  "opt.owner": "مالك / مؤسس",
  "opt.investor": "مستثمر",
  "opt.partner": "شريك",
  "opt.director": "مدير / تنفيذي",
  "opt.manager": "مدير صالة",
  "opt.procurement": "مشتريات / توريد",
  "opt.architect": "مهندس معماري / مصمم",
  "opt.consultant": "استشاري",
  "opt.trainer": "مدرب شخصي",
  "opt.whatsapp": "واتساب",
  "opt.phone": "مكالمة هاتفية",
  "opt.email": "بريد إلكتروني",

  // Form — validation
  "err.projectType": "يرجى اختيار ما تخطط لبنائه.",
  "err.franchiseStatus": "يرجى تحديد وضعك فيما يتعلق بالامتياز.",
  "err.locationStatus": "يرجى اختيار حالة موقعك.",
  "err.facilityArea": "يرجى اختيار المساحة التقريبية لمنشأة اللياقة.",
  "err.projectStage": "يرجى اختيار مرحلة مشروعك.",
  "err.openingTimeline": "يرجى اختيار الإطار الزمني المتوقع للافتتاح.",
  "err.investmentBand": "يرجى اختيار استثمارك التقديري في المعدات.",
  "err.projectNeed": "يرجى اختيار احتياج واحد على الأقل للمشروع.",
  "err.equipmentListStatus": "يرجى اختيار حالة قائمة المعدات.",
  "err.logisticsPreference": "يرجى اختيار تفضيل اللوجستيات.",
  "err.purchaseMethod": "يرجى اختيار خطة الشراء.",
  "err.competitorComparison": "يرجى إخبارنا إذا كنت تقارن العلامات.",
  "err.decisionRole": "يرجى اختيار دورك في هذا المشروع.",
  "err.country": "يرجى اختيار بلد المشروع.",
  "err.city": "يرجى إدخال مدينة المشروع.",
  "err.firstName": "يرجى إدخال اسمك الأول.",
  "err.lastName": "يرجى إدخال اسم عائلتك.",
  "err.email": "يرجى إدخال بريد إلكتروني صالح.",
  "err.phone": "يرجى إدخال رقم واتساب / الهاتف.",
  "err.preferredContact": "يرجى اختيار طريقة التواصل المفضلة.",
  "err.privacyConsent": "يرجى قبول موافقة الخصوصية لإرسال مشروعك.",
  "err.submit": "حدث خطأ أثناء إرسال مشروعك. يرجى المحاولة مرة أخرى.",

  // Form — consent & success
  "consent.privacy": "أوافق على معالجة YANRE FITNESS EUROPE لمعلوماتي للتواصل معي بشأن هذا المشروع.",
  "consent.marketing": "أرغب أيضًا في تلقي أخبار وعروض YANRE FITNESS EUROPE من حين لآخر. (اختياري)",
  "success.title1": "تم استلام المشروع",
  "success.body": "شكرًا لك. سيقوم خبير من YANRE FITNESS EUROPE بمراجعة مشروعك والتواصل معك عبر قناتك المفضلة.",
  "success.reference": "المرجع",

  // ===== Section copy =====
  "wi.h1a": "تبحث عن عملك القادم؟",
  "wi.h1b": "فكّر في اللياقة.",
  "wi.fitnessCol": "قطاع اللياقة",
  "wi.retailCol": "التجزئة التقليدية",
  "wi.f1": "اشتراكات شهرية متكررة",
  "wi.f2": "لا مخزون بضائع",
  "wi.f3": "لا إعادة تخزين يومية",
  "wi.f4": "وصول مدفوع مسبقًا / متكرر",
  "wi.f5": "إمكانية تشغيل مرنة",
  "wi.f6": "إدارة رقمية",
  "wi.f7": "المعدات = أصل إنتاجي طويل الأجل",
  "wi.r1": "البيع كل يوم",
  "wi.r2": "إدارة المخزون",
  "wi.r3": "مشتريات مستمرة",
  "wi.r4": "إيراد من معاملة إلى معاملة",
  "wi.r5": "تشغيل قائم على المخزون",
  "wi.r6": "تعقيد تشغيلي أكبر",
  "wi.r7": "يجب أن يدور المخزون باستمرار",
  "wi.note": "مقارنة هيكلية لنماذج الأعمال — وليست حكمًا على قطاعات أخرى.",
  "mp.s1": "إيرادات سوق اللياقة الأوروبي في 2025",
  "mp.s2": "أعضاء أندية اللياقة في أوروبا في 2025",
  "mp.s3": "متوسط النمو العالمي لإيرادات قطاع اللياقة في 2024",
  "mp.s4": "متوسط هامش EBITDA بين المشغلين في دراسة HFA المرجعية",
  "mp.opsLabel": "كبار المشغلين يتوسعون",
  "mp.o1": "أعضاء أضافهم أكبر 20 مشغلًا في أوروبا في 2025",
  "mp.o2": "الإيرادات المجمعة لأكبر 20 مشغلًا في أوروبا في 2025",
  "mp.o3": "صفقات اندماج واستحواذ كبرى في اللياقة الأوروبية في 2025",
  "mp.src": "المصادر: Health & Fitness Association · EuropeActive / Deloitte. بيانات معيارية للقطاع — لا تضمن نتائج فردية.",
  "nf.h1a": "لست بحاجة إلى أن تأتي من",
  "nf.h1b": "قطاع اللياقة.",
  "nf.b1": "أنت تجلب الاستثمار ورؤية العمل.",
  "nf.b2": "ونحن نساعد في هيكلة جانب المعدات من المشروع.",
  "fd.h1a": "تخلَّص من الوسطاء.",
  "fd.h1b": "وليس من الدعم.",
  "fd.tradLabel": "النموذج التقليدي",
  "fd.directLabel": "YANRE مباشرة من المصنع",
  "fd.t1": "المصنّع",
  "fd.t2": "الموزع / المستورد",
  "fd.t3": "الوكيل / بائع التجزئة",
  "fd.t4": "العميل",
  "fd.customer": "العميل",
  "fd.trust": "يتم عقد المعدات والمدفوعات مباشرة مع YANRE FITNESS.",
  "fd.supportLabel": "الشراء المباشر من المصنع لا يعني أنك وحدك",
  "fd.s1": "استشارات مخصصة",
  "fd.s2": "إرشاد فني",
  "fd.s3": "اختيار المعدات",
  "fd.s4": "دعم المشروع",
  "fd.s5": "تنسيق لوجستي اختياري",
  "fd.s6": "دعم ما بعد البيع",
  "fd.s7": "ضمان المصنع",
  "pp.h1a": "عملية واضحة.",
  "pp.h1b": "من المشروع إلى ما بعد البيع.",
  "pp.1.t": "موجز المشروع",
  "pp.1.b": "يشرح العميل المساحة والمفهوم والاستثمار والجدول الزمني.",
  "pp.2.t": "استشارات YANRE",
  "pp.2.b": "اختيار المعدات، إرشاد فني وتهيئة المشروع.",
  "pp.3.t": "عقد المصنع",
  "pp.3.b": "عرض نهائي وطلب معدات رسمي مباشرة مع YANRE FITNESS.",
  "pp.4.t": "دفعة 30% للمصنع",
  "pp.4.b": "دفعة أولى قياسية تُدفع مباشرة إلى YANRE FITNESS ويدخل الطلب مرحلة الإنتاج.",
  "pp.5.t": "الإنتاج",
  "pp.5.b": "تصنيع المعدات وتجهيزها.",
  "pp.6.t": "دفعة 70% للمصنع",
  "pp.6.b": "الرصيد القياسي يُدفع مباشرة إلى YANRE FITNESS بعد الإنتاج وقبل الشحن، وفقًا للعقد الرسمي.",
  "pp.7.t": "الشحن الدولي",
  "pp.7.b": "يمكن للعميل استخدام مشغل لوجستي خاص به أو طلب تنسيق لوجستي.",
  "pp.8.t": "ما بعد البيع",
  "pp.8.b": "دعم مستمر وضمان مصنع بعد التسليم.",
  "pp.payTitle": "100% من مدفوعات المعدات تتم مباشرة إلى YANRE FITNESS.",
  "pp.paySub": "لا تُدفع أي مدفوعات معدات إلى وكلاء أو مستشارين أو وسطاء.",
  "pp.disclaimer": "هيكل الدفع القياسي معروض. تُحدد الشروط التجارية والدفع النهائية في عقد البيع الرسمي لـ YANRE FITNESS.",
  "fe.h1a": "مصمم ليؤدي.",
  "fe.h1b": "مصنوع ليُرى.",
  "fe.tagline": "معداتك جزء من علامتك التجارية.",
  "fe.i0.cat": "قوة بأوزان مُنتقاة",
  "fe.i0.series": "73 Tough Series",
  "fe.i0.stmt": "أجهزة قوة بأوزان مُنتقاة مصممة للاستخدام الاحترافي اليومي.",
  "fe.i1.cat": "بليت لودد",
  "fe.i1.series": "Plate-Loaded Power",
  "fe.i1.stmt": "أجهزة بليت لودد مبنية حول الحركة الطبيعية.",
  "fe.i2.cat": "وظيفة مزدوجة",
  "fe.i2.series": "C4D وظيفة مزدوجة",
  "fe.i2.stmt": "محطتان في مساحة واحدة — أقصى كثافة تدريب.",
  "fe.i3.cat": "كارديو تجاري",
  "fe.i3.series": "كارديو تجاري",
  "fe.i3.stmt": "كارديو مصمم لبيئات تجارية لا تتوقف.",
  "dd.h1a": "الفرق",
  "dd.h1b": "في التفاصيل.",
  "dd.0.t": "هندسة أصلية",
  "dd.0.s": "تصميم من تطوير YANRE.",
  "dd.1.t": "تصميم حاصل على براءة اختراع",
  "dd.1.s": "تصميم معدات أصلي وحاصل على براءة اختراع.",
  "dd.2.t": "بناء الهيكل",
  "dd.2.s": "هندسة الهيكل والأنابيب عن قرب.",
  "dd.3.t": "تصميم هيكل منحنٍ",
  "dd.3.s": "هندسة هيكل مصممة حول الحركة.",
  "dd.4.t": "التنجيد والوسائد",
  "dd.4.s": "تنجيد احترافي وخياطة وتشطيب.",
  "dd.5.t": "نظام الكابلات / البكرات / الأدلة",
  "dd.5.s": "مكونات حركة دقيقة.",
  "dd.6.t": "الميكانيكا الحيوية",
  "dd.6.s": "محاور ومسارات حركة مصممة حول الجسم.",
  "dd.7.t": "بناء بمستوى تجاري",
  "dd.7.s": "مصمم للمتانة والاستخدام الاحترافي اليومي.",
  "bt.0": "صالة رياضية تجارية",
  "bt.1": "نادي لياقة بريميوم",
  "bt.2": "صالة بوتيك",
  "bt.3": "استوديو تدريب شخصي",
  "bt.4": "صالة قوة / أداء",
  "bt.5": "منشأة تدريب وظيفي",
  "bt.6": "صالة منزلية خاصة احترافية",
  "bt.7": "صالة سكنية / مجمع سكني",
  "bt.8": "فندق / منتجع",
  "bt.9": "لياقة الشركات",
  "bt.10": "موقع فرانشايز",
  "wy.h1a": "مصمم بالخبرة.",
  "wy.h1b": "مبني للأداء.",
  "wy.p1.t": "التصنيع",
  "wy.p1.b": "إنتاج داخلي لأنظمة قوة بمستوى تجاري — مصممة ومصنوعة من YANRE، وليست مجمعة من تصاميم طرف ثالث.",
  "wy.p2.t": "الهندسة والميكانيكا الحيوية",
  "wy.p2.b": "تصميم أصلي منذ 1997، مع أكثر من 200 براءة اختراع تغطي هندسة المعدات وميكانيكا الحركة الحيوية.",
  "wy.p3.t": "متانة تجارية",
  "wy.p3.b": "معدات مصممة للاستخدام الاحترافي اليومي، معتمدة وفق معايير CE وTÜV وISO.",
  "wy.p4.t": "تطوير المنتجات",
  "wy.p4.b": "مجموعة يقودها المصنّع — من 73 Tough Series إلى خطوط بليت لودد، وأجهزة الوظيفة المزدوجة والكارديو التجاري.",
  "wy.p5.t": "خبرة دولية",
  "wy.p5.b": "موثوقة من صالات احترافية في أكثر من 110 دول، مع أكثر من 34,950 مشروع صالة مُسلَّم حول العالم.",
  "wy.proof0": "منذ 1997",
  "wy.proof1": "أكثر من 200 براءة اختراع",
  "wy.proof2": "أكثر من 110 دول",
  "wy.proof3": "CE · TÜV · ISO",
  "wy.proof4": "أكثر من 34,950 مشروعًا",
  "fo.navFactory": "المصنع",
  "fo.navFounder": "الرجل خلف الآلة",
  "fo.h1a": "الرجل",
  "fo.h1b": "خلف",
  "fo.h1c": "الآلة.",
  "fo.role": "المؤسس وكبير المصممين",
  "fo.body": "رياضي ومهندس ومؤسس YANRE. منذ 1997، يبني آلات لمن يقدّرون الهندسة فوق التسويق.",
  "fo.quote": "«لفهم الآلة، عليك أن تفهم الرجل خلفها.»",
  "fo.st1.t": "البداية",
  "fo.st1.b": "في 1991، لم يكن جورج يانغ مؤسسًا بعد — كان فنيًا يصلح أجهزة الصالات لمنتخب الصين الوطني للرياضيين. كشف الإصلاح الحقيقة؛ كان يتدرب بنفسه على الآلات ليشعر تمامًا أين تفشل.",
  "fo.st2.t": "المشكلة",
  "fo.st2.b": "حتى «أفضل» العلامات في العالم كانت بها عيوب — لحامات ضعيفة وزوايا رديئة وتصاميم تتجاهل جسم الإنسان. القيود التي رآها شكّلت طريقة مختلفة تمامًا في التفكير في المعدات.",
  "fo.st3.t": "التأسيس",
  "fo.st3.b": "في 1997، توقف عن تصحيح أخطاء الآخرين ووضع معياره الخاص — مؤسسًا Yangrui Fitness في بكين، على اسم ابنه. تطور الاسم من Yangrui إلى Yanre ثم YR؛ أما المعيار فلم يتغير أبدًا.",
  "fo.st4.t": "المهندس",
  "fo.st4.b": "يرفض المساومة في المواد: فولاذ Q235 مؤهل بسماكة لا تقل عن 3 مم، قضبان 30CrMnSiA، كامات وبكرات POM منخفضة الاحتكاك وكابلات مستوردة من اليابان بتصنيف 1400 كغ. «أتدرب بنفسي على هذه الآلات.»",
  "fo.st5.t": "المصمم",
  "fo.st5.b": "فلسفته نظيفة وبسيطة — التصميم ليس الشكل، بل طريقة العمل. YANRE تبتكر بدل أن تنسخ؛ كانت 73 Series الأولى في العالم بمسارات حركة مستقلة ومتقاربة ومتباعدة.",
  "fo.st6.t": "الرؤية",
  "fo.st6.b": "مصنع حرفيين، لا مستودع صناديق — حد أدنى للطلب بوحدة واحدة، تخصيص حقيقي ودعم مصمم للسنة العاشرة من عمر الصالة، لا لليوم الأول فقط. شريك، لا رئيس.",
  "fo.m1.t": "خبرة فنية مبكرة",
  "fo.m1.b": "فني لمنتخب الصين الوطني للرياضيين.",
  "fo.m2.t": "تأسيس YANRE",
  "fo.m2.b": "تأسست Yangrui Fitness في بكين.",
  "fo.m3.t": "73 Series",
  "fo.m3.b": "الأولى في العالم بمسارات مستقلة ومتقاربة ومتباعدة.",
  "fo.pqA": "«نصنع المنتجات بـ",
  "fo.pqHeart": "قلب",
  "fo.pqB": "، ونصنع المنتجات بـ",
  "fo.pqStandard": "معيار",
  "fo.pqEnd": ".»",
  "fo.c1.t": "المواد",
  "fo.c1.b": "فولاذ Q235، بحد أدنى 3 مم. كامات POM. كابلات 1400 كغ.",
  "fo.c2.t": "الميكانيكا الحيوية",
  "fo.c2.b": "مسارات حركة مصممة حول جسم الإنسان.",
  "fo.c3.t": "المتانة",
  "fo.c3.b": "مصمم ليدوم أكثر من 10 سنوات من الاستخدام الاحترافي.",
  "fo.c4.t": "المعيار",
  "fo.c4.b": "ISO 20957 كنقطة انطلاق — وليس كحد أقصى أبدًا.",
  "cc.h1a": "صالات حقيقية.",
  "cc.h1b": "أعمال حقيقية.",
  "cc.h1c": "YANRE حقيقية.",
  "cc.case0.title": "مظهر بريميوم. تركيب احترافي.",
  "cc.case1.title": "تخطيط بسيط. تركيب متين.",
  "cc.case2.title": "أسلوب وظيفي. معدات احترافية.",
  "cc.videoPending": "فيديو المشروع الكامل متاح عند الطلب",
  "lg.h1a": "معداتك. وجهتك.",
  "lg.h1b": "اختيارك.",
  "lg.option": "الخيار",
  "lg.o1.t": "استخدم شريكك اللوجستي",
  "lg.o1.b": "اعمل مع المشغل اللوجستي الذي تثق به بالفعل. نجهز طلبك للتصدير وننسق مع شريكك.",
  "lg.o2.t": "دع التنسيق علينا",
  "lg.o2.b": "اطلب تنسيق لوجستيات YANRE وفق النطاق المتعاقد عليه — من المصنع إلى ميناء الوجهة.",
  "lg.f1": "المصنع",
  "lg.f2": "التصدير",
  "lg.f3": "الشحن البحري",
  "lg.f4": "ميناء الوجهة",
  "lg.disclaimer": "التخليص الجمركي والضرائب والرسوم وخدمات الميل الأخير مشمولة فقط عند التعاقد عليها صراحة.",
  "lg.cta": "أدرج اللوجستيات في مشروعي",
  "as.h1a": "العلاقة لا تنتهي",
  "as.h1b": "عندما تغادر الحاوية.",
  "as.1.t": "ضمان المصنع",
  "as.1.b": "دعم ضمان المصنّع لمعداتك.",
  "as.2.t": "دعم فني",
  "as.2.b": "مساعدة فنية مباشرة، مرتبطة بالأشخاص خلف المعدات.",
  "as.3.t": "دعم قطع الغيار",
  "as.3.b": "دعم قطع غيار بمستوى المصنّع لآلاتك.",
  "as.4.t": "مساعدة ما بعد البيع",
  "as.4.b": "مساعدة مستمرة بعد البيع عقب التسليم.",

  // Cookie consent & policy
  "ck.title": "خيارات الخصوصية",
  "ck.desc": "نستخدم ملفات تعريف الارتباط الاختيارية للتحليلات والإعلانات بموافقتك فقط. يمكنك تغيير اختيارك أو سحبه في أي وقت.",
  "ck.acceptAll": "قبول الكل",
  "ck.reject": "رفض غير الضرورية",
  "ck.manage": "إدارة التفضيلات",
  "ck.save": "حفظ التفضيلات",
  "ck.necessary": "ضرورية",
  "ck.necessaryDesc": "ضرورية لعمل الموقع. نشطة دائمًا.",
  "ck.analytics": "التحليلات",
  "ck.analyticsDesc": "إحصاءات استخدام مجهولة تساعدنا على تحسين هذا الموقع.",
  "ck.advertising": "الإعلانات",
  "ck.advertisingDesc": "تُستخدم لقياس الحملات وعرض إعلانات ذات صلة.",
  "ck.alwaysOn": "نشطة دائمًا",
  "ck.prefsTitle": "تفضيلات ملفات تعريف الارتباط",
  "ck.policy": "سياسة ملفات تعريف الارتباط",
  "ck.privacy": "سياسة الخصوصية",
  "footer.cookiePrefs": "تفضيلات ملفات تعريف الارتباط",
  "cp.title": "سياسة ملفات تعريف الارتباط",
  "cp.updated": "آخر تحديث: يوليو 2026",
  "cp.intro": "توضح هذه الصفحة كيفية استخدام YANRE FITNESS EUROPE لملفات تعريف الارتباط والتقنيات المشابهة على هذا الموقع، وكيف يمكنك التحكم فيها.",
  "cp.s1t": "ما الذي نخزنه",
  "cp.s1b": "عندما تختار موافقتك، نخزن فقط هذا الاختيار (ضرورية، تحليلات، إعلانات) في التخزين المحلي لمتصفحك. لا يحتوي على أي معلومات شخصية ويُستخدم فقط لتذكر تفضيلاتك بين الزيارات.",
  "cp.s2t": "فئات ملفات تعريف الارتباط",
  "cp.s3t": "Google Tag Manager ووضع الموافقة",
  "cp.s3b": "يحمّل هذا الموقع حاوية Google Tag Manager واحدة مع وضع الموافقة v2 من Google. يتم ضبط كل التخزين الاختياري (التحليلات والإعلانات) على «denied» افتراضيًا ولا يتم تفعيله إلا بعد موافقتك الصريحة. لا توجد أي علامات تحليلات أو إعلانات مثبتة مباشرة على هذا الموقع.",
  "cp.s4t": "إدارة موافقتك",
  "cp.s4b": "يمكنك تغيير موافقتك أو سحبها في أي وقت عبر رابط «تفضيلات ملفات تعريف الارتباط» في تذييل الموقع. يسري السحب فورًا.",
  "cp.s5t": "اتصل بنا",
  "cp.privacyT": "الخصوصية",
  "cp.privacyB": "سياسة الخصوصية الكاملة قيد الإعداد. لأي سؤال أو طلب يتعلق ببياناتك الشخصية، تواصل معنا عبر البريد الإلكتروني أعلاه.",
  "cp.back": "العودة إلى الرئيسية",

  "q.fullName": "الاسم الكامل",
  "opt.upgrade-expand": "تطوير / توسعة نادٍ قائم",
  // ===== PERSONAL TRAINER STUDIO (pts.*) — ar =====
  "pts.seo.title": "استوديو التدريب الشخصي — معدات جيم احترافية | YANRE FITNESS",
  "pts.seo.description": "أنشئ استوديو التدريب الشخصي الخاص بك مع معدات YANRE الاحترافية، مباشرةً من المصنّع. باقات انطلاق ذكية، وتخطيط مدروس للمساحة، ودعم مباشر من المصنع.",
  "pts.nav.talk": "تحدث مع أخصائي",
  "pts.header.cta": "أنشئ الاستوديو الخاص بي",
  "pts.hero.label": "استوديو التدريب الشخصي",
  "pts.hero.line1": "استوديوك الخاص.",
  "pts.hero.line2": "عملاؤك.",
  "pts.hero.line3": "عملك التجاري.",
  "pts.hero.subhead": "أنشئ استوديو التدريب الاحترافي الخاص بك مع YANRE.",
  "pts.hero.copy": "من أول استوديو خاص بك إلى منشأة تدريب شخصي فاخرة — معدات بمعايير تجارية، وتخطيط ذكي للمساحة، ودعم مباشر من المصنّع.",
  "pts.hero.ctaPrimary": "أنشئ الاستوديو الخاص بي",
  "pts.hero.ctaSecondary": "تحدث مع أخصائي",
  "pts.hero.trust.0": "جودة تجارية",
  "pts.hero.trust.1": "مباشرة من المصنّع",
  "pts.hero.trust.2": "ضمان المصنع",
  "pts.hero.trust.3": "دعم لوجستي",
  "pts.journey.label": "مرحلة التحول",
  "pts.journey.h2a": "من مدرب شخصي",
  "pts.journey.h2b": "إلى مالك استوديو.",
  "pts.journey.copy": "تدريب العملاء في صالة شخص آخر يبني تجارته هو. أما استوديوك الخاص فيبني تجارتك أنت — مساحتك، وعلاقاتك مع عملائك، وعلامتك التجارية، وأصلك الخاص. الاستقلالية تبدأ بقاعة والمعدات المناسبة.",
  "pts.journey.0": "مدرب شخصي",
  "pts.journey.1": "استوديوك الخاص",
  "pts.journey.2": "عملاؤك الخاصون",
  "pts.journey.3": "علامتك التجارية الخاصة",
  "pts.journey.4": "عملك التجاري الخاص",
  "pts.journey.direct": "مباشرةً من المصنّع.",
  "pts.journey.directCopy": "جهّز استوديوك بمعدات احترافية تشتريها مباشرةً من YANRE — المصنّع الذي يهندس وينتج كل آلة.",
  "pts.journey.note": "لا وعود ولا طرق مختصرة — فقط الهيكل اللازم لتحويل حرفتك إلى عمل تجاري تملكه.",
  "pts.pkg.label": "طريقتان للبدء",
  "pts.pkg.h2a": "ابدأ بذكاء.",
  "pts.pkg.h2b": "وانمُ بشروطك.",
  "pts.pkg.intro": "يبدأ الاستوديو الاحترافي بباقة معدات مختارة بعناية — وينمو مع الوقت. كل تشكيلة تُصمم خصيصاً لمساحتك ومنهجية تدريبك ومستوى استثمارك.",
  "pts.pkg.tag": "باقة",
  "pts.pkg.starter.name": "Starter",
  "pts.pkg.starter.pos": "كل ما تحتاجه لافتتاح استوديو تدريب خاص واحترافي.",
  "pts.pkg.starter.i0": "الاستوديو الأول",
  "pts.pkg.starter.i1": "المدربون الشخصيون",
  "pts.pkg.starter.i2": "المساحات الصغيرة",
  "pts.pkg.starter.i3": "تدريب 1 إلى 3",
  "pts.pkg.starter.i4": "تدريب شبه خاص",
  "pts.pkg.starter.concept": "تشكيلة مختارة بعناية من أجهزة القوة الأساسية والمعدات الوظيفية والأوزان الحرة.",
  "pts.pkg.starter.cta": "أنشئ استوديو Starter الخاص بي",
  "pts.pkg.studiopro.name": "Studio Pro",
  "pts.pkg.studiopro.pos": "تجهيز احترافي متكامل لعمل تدريب شخصي فاخر.",
  "pts.pkg.studiopro.i0": "المدربون الشخصيون المتمرسون",
  "pts.pkg.studiopro.i1": "الاستوديوهات الفاخرة",
  "pts.pkg.studiopro.i2": "قدرة استيعابية أعلى للعملاء",
  "pts.pkg.studiopro.i3": "تدريب المجموعات الصغيرة",
  "pts.pkg.studiopro.i4": "تدريب الأداء العالي",
  "pts.pkg.studiopro.concept": "تشكيلة أشمل من أجهزة القوة والمعدات الوظيفية والأوزان الحرة وأجهزة الكارديو.",
  "pts.pkg.studiopro.cta": "أنشئ استوديو Studio Pro الخاص بي",
  "pts.pkg.idealFor": "مثالي لـ",
  "pts.pkg.conceptLabel": "مفهوم المعدات",
  "pts.pkg.quote": "اطلب عرض مشروعك",
  "pts.pkg.note": "لا أسعار ثابتة على الإنترنت — يتم تسعير كل استوديو كمشروع، يُصمم وفق مساحتك ومنهجيتك ومستوى استثمارك.",
  "pts.eq.label": "مصممة للتدريب الحقيقي",
  "pts.eq.h2a": "جودة تجارية.",
  "pts.eq.h2b": "مصنوعة للاستخدام الاحترافي اليومي.",
  "pts.eq.copy": "نفس خطوط المعدات التي تخدم الصالات التجارية — هياكل مُهندَسة، وحركة حاصلة على براءة اختراع، ومتانة مختبَرة في المصنع — مصممة بذكاء لاستوديو تدريب خاص.",
  "pts.eq.strength": "أجهزة القوة",
  "pts.eq.functional": "التدريب الوظيفي",
  "pts.eq.freeweights": "الأوزان الحرة",
  "pts.eq.benches": "المقاعد والرفوف",
  "pts.eq.cable": "محطات الكابلات",
  "pts.eq.cardio": "الكارديو",
  "pts.eq.alt.strength": "معدات قوة احترافية من YANRE لاستوديوهات التدريب الشخصي",
  "pts.eq.alt.functional": "معدات تدريب وظيفي من YANRE للاستوديوهات الرياضية الاحترافية",
  "pts.eq.alt.freeweights": "معدات أوزان حرة احترافية من YANRE لاستوديوهات التدريب الشخصي",
  "pts.eq.alt.benches": "مقاعد ورفوف احترافية من YANRE لاستوديوهات التدريب الشخصي",
  "pts.eq.alt.cable": "محطات كابلات احترافية من YANRE لاستوديوهات التدريب الشخصي",
  "pts.eq.alt.cardio": "معدات كارديو احترافية من YANRE لاستوديوهات التدريب الشخصي",
  "pts.space.label": "تخطيط المساحة",
  "pts.space.h2a": "مساحتك.",
  "pts.space.h2b": "مشروعك.",
  "pts.space.copy": "لا يوجد استوديوهان متطابقان. تُصمم تشكيلة المعدات والمخطط حول واقعك — وليست حزمة ثابتة من الكتالوج.",
  "pts.space.f0": "المساحة المتاحة",
  "pts.space.f1": "منهجية التدريب",
  "pts.space.f2": "عدد العملاء المتزامنين",
  "pts.space.f3": "مستوى الاستثمار",
  "pts.space.f4": "الشراء المباشر من المصنع",
  "pts.space.f4d": "معدات YANRE احترافية دون طبقات وسيطة غير ضرورية.",
  "pts.space.f5": "استوديو جاهز للتشغيل",
  "pts.space.f5d": "معدات احترافية ومخطط ذكي ومفهوم استوديو متكامل جاهز للعمل.",
  "pts.space.cta": "ابدأ مشروع الاستوديو الخاص بي",
  "pts.direct.label": "مباشرة من المصنّع",
  "pts.direct.h2a": "بلا وسطاء.",
  "pts.direct.h2b": "بلا تنازلات.",
  "pts.direct.copy": "YANRE هي المصنّع — تهندس وتنتج معداتها الاحترافية منذ عام 1997. مشروعك وعقد معداتك وضمانك موجودان مباشرةً لدى المصنع الذي يصنع آلاتك.",
  "pts.direct.p0": "معدات بمعايير تجارية",
  "pts.direct.p1": "علاقة مباشرة مع المصنّع",
  "pts.direct.p2": "ضمان مدعوم من المصنع",
  "pts.direct.p3": "دعم لوجستي دولي",
  "pts.direct.p4": "استشارات المشاريع",
  "pts.direct.p5": "دعم ما بعد البيع",
  "pts.process.label": "كيف نعمل",
  "pts.process.h2a": "عملية واضحة.",
  "pts.process.h2b": "من الفكرة إلى يوم الافتتاح.",
  "pts.process.1.t": "الاستشارة",
  "pts.process.1.b": "نفهمك أنت ومساحتك ومفهومك ومستوى استثمارك.",
  "pts.process.2.t": "المشروع",
  "pts.process.2.b": "معاً نحدد تشكيلة المعدات ومخطط الاستوديو.",
  "pts.process.3.t": "الطلب — 30٪",
  "pts.process.3.b": "أكّد المشروع وابدأ الإنتاج بدفعة 30٪ للمصنع.",
  "pts.process.4.t": "الإنتاج",
  "pts.process.4.b": "تصنّع YANRE معداتك وتجهزها.",
  "pts.process.5.t": "70٪ قبل الشحن",
  "pts.process.5.b": "يُسدد الرصيد المتبقي قبل الشحن وفق العقد الرسمي.",
  "pts.process.6.t": "الشحن",
  "pts.process.6.b": "لوجستيات دولية منسقة لمشروعك.",
  "pts.process.7.t": "ما بعد البيع",
  "pts.process.7.b": "دعم مدعوم من المصنع بعد التركيب.",
  "pts.monetize.label": "استثمر ساعات الاستوديو المتاحة",
  "pts.monetize.h2a": "اجعل استوديوك يعمل",
  "pts.monetize.h2b": "حتى عندما لا تكون موجوداً.",
  "pts.monetize.copy": "ليس على استوديوك أن يولّد قيمة فقط عندما تدرّب عملاءك. يمكن أن تصبح الساعات المتاحة فرصة دخل إضافية بمنح مدربين شخصيين آخرين حق الوصول إلى مساحة التدريب الاحترافية الخاصة بك.",
  "pts.monetize.clients": "عملاؤك",
  "pts.monetize.clientsSub": "جلسات التدريب الخاصة بك",
  "pts.monetize.hours": "الساعات المتاحة",
  "pts.monetize.hoursSub": "مدربون آخرون يستخدمون استوديوك",
  "pts.monetize.revenue": "مصدر دخل إضافي",
  "pts.monetize.revenueSub": "استغل مساحتك بشكل أفضل على مدار اليوم",
  "pts.monetize.closeA": "الاستوديو ملكك.",
  "pts.monetize.closeB": "وأنت من يتحكم في الجدول.",
  "pts.form.label": "ابدأ مشروع الاستوديو الخاص بك",
  "pts.form.h2a": "أخبرنا عن",
  "pts.form.h2b": "استوديوك.",
  "pts.form.sub": "دقيقتان. يرد عليك أخصائي بعرض معدات ملموس يناسب مساحتك وميزانيتك.",
  "pts.form.intro.sub1": "٤ خطوات سريعة.",
  "pts.form.intro.sub2": "حل متكامل لاستوديو التدريب الخاص بك.",
  "pts.form.intro.support": "أخبرنا عن الاستوديو الخاص بك في ٤ خطوات بسيطة فقط. سيفهم فريقنا احتياجاتك ويساعدك في بناء الحل المناسب — مع التوريد المباشر من مصنع YANRE FITNESS في الصين، واستشارة احترافية ودعم ما بعد البيع.",
  "pts.form.intro.minute": "دقيقة واحدة للإكمال",
  "pts.form.progress": "الخطوة",
  "pts.form.back": "رجوع",
  "pts.form.continue": "متابعة",
  "pts.form.submit": "احصل على مشروع الاستوديو الخاص بي",
  "pts.form.sending": "جارٍ الإرسال…",
  "pts.form.err.step": "يرجى إكمال الحقول المطلوبة للمتابعة.",
  "pts.form.err.submit": "حدث خطأ أثناء إرسال مشروعك. حاول مرة أخرى.",
  "pts.success.title": "تم استلام مشروع الاستوديو الخاص بك.",
  "pts.success.body": "سيراجع أخصائي YANRE معلوماتك ويتواصل معك لمناقشة استوديوك ومتطلبات المعدات والخطوات التالية.",
  "pts.success.reference": "المرجع",
  "pts.success.cta": "زيارة YANRE FITNESS",
  "pts.q.areYou": "ما الذي يصفك بشكل أفضل؟",
  "pts.q.planning": "ما الذي تخطط له؟",
  "pts.q.package": "أي باقة استوديو تهمك؟",
  "pts.q.location": "هل لديك موقع بالفعل؟",
  "pts.q.size": "المساحة التقريبية للاستوديو:",
  "pts.q.timeline": "متى تخطط لافتتاح استوديوك؟",
  "pts.q.investment": "ما هي ميزانية الاستثمار التقديرية؟ (USD)",
  "pts.q.needs": "ما الذي تحتاجه؟",
  "pts.q.needsHint": "اختر كل ما ينطبق.",
  "pts.q.country": "الدولة",
  "pts.q.city": "المدينة",
  "pts.q.fullName": "الاسم الكامل",
  "pts.q.email": "البريد الإلكتروني",
  "pts.q.phone": "الهاتف / واتساب",
  "pts.q.company": "الشركة / اسم الاستوديو (اختياري)",
  "pts.q.selectCountry": "اختر الدولة",
  "pts.step.1": "الاستوديو",
  "pts.step.2": "المساحة",
  "pts.step.3": "الاستثمار",
  "pts.step.4": "التواصل",
  "pts.step.5": "احتياجات المعدات",
  "pts.step.6": "التواصل",
  "pts.opt.role.personal-trainer": "مدرب شخصي",
  "pts.opt.role.sc-coach": "مدرب قوة وتكييف",
  "pts.opt.role.studio-owner": "مالك استوديو",
  "pts.opt.role.investor-entrepreneur": "مستثمر / رائد أعمال",
  "pts.opt.role.other": "أخرى",
  "pts.opt.plan.first-studio": "افتتاح أول استوديو لي",
  "pts.opt.plan.upgrade-studio": "تطوير استوديوي الحالي",
  "pts.opt.plan.another-location": "افتتاح موقع آخر",
  "pts.opt.pkg.starter": "STARTER",
  "pts.opt.pkg.studio-pro": "STUDIO PRO",
  "pts.opt.pkg.need-help": "أحتاج مساعدة في الاختيار",
  "pts.opt.loc.confirmed": "نعم",
  "pts.opt.loc.looking": "أبحث حالياً",
  "pts.opt.loc.not-yet": "ليس بعد",
  "pts.opt.size.under-50": "أقل من 50 م²",
  "pts.opt.size.50-100": "50–100 م²",
  "pts.opt.size.100-200": "100–200 م²",
  "pts.opt.size.over-200": "أكثر من 200 م²",
  "pts.opt.size.undefined": "لم يُحدد بعد",
  "pts.opt.time.1-2": "1–2 شهر",
  "pts.opt.time.2-4": "2–4 أشهر",
  "pts.opt.time.4-6": "4–6 أشهر",
  "pts.opt.time.6-plus": "أكثر من 6 أشهر",
  "pts.opt.inv.under-10k": "أقل من 10,000",
  "pts.opt.inv.10-20k": "10,000–20,000",
  "pts.opt.inv.20-40k": "20,000–40,000",
  "pts.opt.inv.40-80k": "40,000–80,000",
  "pts.opt.inv.80k-plus": "أكثر من USD 80,000",
  "pts.opt.need.complete-studio-equipment": "تجهيز استوديو متكامل",
  "pts.opt.need.strength": "أجهزة القوة",
  "pts.opt.need.functional": "التدريب الوظيفي",
  "pts.opt.need.cardio": "أجهزة الكارديو",
  "pts.opt.need.full-project-help": "أحتاج مساعدة في المشروع بالكامل",
  "pts.opt.role.gym-owner-operator": "مالك / مشغّل نادٍ",
  "pts.opt.inv.under-20k": "أقل من USD 20,000",
  "pts.opt.inv.20-30k": "USD 20,000–30,000",
  "pts.opt.inv.30-50k": "USD 30,000–50,000",
  "pts.opt.inv.50-80k": "USD 50,000–80,000",
  "err.phoneInvalid": "يرجى إدخال رقم هاتف صالح للبلد المحدد.",
};
